import MyTabs from '../../components/MyTabs';
import Section1 from './RCPrimaryForm';

const GeneralResearchCategories = () => {

    const tabs = [
        { id: "section1", title: "Research Categories Info", Component: Section1  },
      ];

    return (
        <>
            <MyTabs list={tabs}/>
        </>
    )
};

export default GeneralResearchCategories;